import { useWorkspace } from "@/api/session";
import { Money, Tooltip } from "@/components";
import { MISSING_VALUE } from "@/lib/format";
import { countryName } from "@/lib/regions";
import type { SupplyOffer } from "../api";
import styles from "./OfferPrice.module.css";

/** Why an offer's price is another market's, or "" when it is the workspace market's own. */
export function otherMarketNote(offer: SupplyOffer, workspaceMarket: string): string {
  if (!offer.other_market) return "";
  const theirs = offer.market ? countryName(offer.market) : "another market";
  return `The store shows no price for ${countryName(workspaceMarket)}; this is its price for ${theirs}.`;
}

/** A pack price in the workspace currency, marked with its market when the store shows no price for
 * the workspace's own. */
export function OfferPrice({ offer }: { offer: SupplyOffer }) {
  const workspace = useWorkspace();
  if (offer.price_minor === null) return <span className={styles.missing}>{MISSING_VALUE}</span>;
  const price = <Money minor={offer.price_minor} currency={offer.currency} />;
  const note = otherMarketNote(offer, workspace?.market_country || "CA");
  if (!note) return price;
  return (
    <Tooltip content={note}>
      <button type="button" className={styles.hint}>
        {price}
        {offer.market ? <span className={styles.market}>{offer.market}</span> : null}
      </button>
    </Tooltip>
  );
}
